/**
 * Etape 4 (parcours A) : « Type de produit » — prototype v7.4, WizardOffre/exclu.
 *
 * Deux boutons cote a cote, « Générique » / « Ma marque », et une phrase qui
 * dit ce que chaque choix implique. Le prototype ne demande rien de plus.
 *
 * Ce que ca devient dans nos donnees : un produit du catalogue reste partage ;
 * « Ma marque » signifie que l'offre porte un NOM et une MARQUE propres
 * (`customName`, `brandName`) — c'est ce que voit le client, et c'est ce qui
 * distingue « la confiture de Mme X » de « confiture ». Les deux champs
 * n'apparaissent donc que dans ce cas, sous la phrase, sans ecran de plus.
 * L'exclusivite au sens strict (personne d'autre sous cette reference) passe
 * par le parcours « proposer un produit », qui la demande a Manrina.
 */
function StepTypeProduit({ product, exclusif, onExclusifChange, brandName, onBrandNameChange, customName, onCustomNameChange }) {
  const champ = 'w-full rounded-[14px] px-3.5 py-3 text-base text-ink outline-none'
  const champStyle = { background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(7,62,61,0.12)' }
  return (
    <div>
      <p className="text-[13px] text-ink/65 mb-3">Ce produit est-il générique ou votre marque ?</p>

      <div className="flex gap-2 mb-3">
        {[[false, '🌍 Générique'], [true, '🔒 Ma marque']].map(([v, l]) => (
          <button
            key={l}
            onClick={() => onExclusifChange(v)}
            className="flex-1 rounded-2xl px-2 py-[13px] text-[13.5px] font-extrabold transition-colors"
            style={exclusif === v
              ? { background: 'rgb(var(--c-green))', color: 'rgb(var(--c-creme))' }
              : { background: 'rgba(255,255,255,0.55)', color: 'rgba(7,62,61,0.55)' }}
          >
            {l}
          </button>
        ))}
      </div>

      <p className="text-[12px] text-ink/60 leading-relaxed">
        {exclusif
          ? 'Ma marque : votre recette, votre nom (ex. votre confiture). C\'est ce nom que le client verra.'
          : 'Générique : la référence est partagée — d\'autres producteurs peuvent proposer le même produit.'}
      </p>

      {exclusif && (
        <div className="mt-4 flex flex-col gap-2.5 animate-fade-up">
          <label className="block">
            <span className="block text-[11px] uppercase tracking-wider text-ink/45 mb-1">Nom de votre produit</span>
            <input
              value={customName}
              onChange={(e) => onCustomNameChange(e.target.value)}
              placeholder={product?.nom ? `Ex. ${product.nom} de la ferme` : 'Ex. Confiture de la ferme'}
              className={champ}
              style={champStyle}
            />
          </label>
          <label className="block">
            <span className="block text-[11px] uppercase tracking-wider text-ink/45 mb-1">Marque (optionnel)</span>
            <input
              value={brandName}
              onChange={(e) => onBrandNameChange(e.target.value)}
              placeholder="Ex. Ferme Bèlè"
              className={champ}
              style={champStyle}
            />
          </label>
        </div>
      )}
    </div>
  )
}

export default StepTypeProduit
